module.exports = __webpack_public_path__ + "static/img/MarkRobinson.04c9970.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MarkRobinson.jpg
// module id = W32H
// module chunks = 0